<template>
  <div class="">
      <div :style="skin.animation.stat_text_color" class="text-center" style="font-size:small;margin-bottom:-10px">{{tittle_stat}}</div>
      <div class="d-flex">
          <div style="width:15%" :style="skin.animation.div_team1_value">{{team1_value}}</div>
          <div style="width:70%;padding-top: 10px;" class="">
              <div class="col-12 progress mt-25 div_progress_stat" :style="skin.animation.progress_bar2+';height:5px'">
                  <div role="progressbar" aria-valuemin="0" aria-valuemax="100" :aria-valuenow="percent_progress" class="progress-bar" :style="'width: '+percent_progress+'%;'+skin.animation.progress_bar1">
                  </div>
              </div>
          </div>
          <div style="width:15%" :style="skin.animation.div_team2_value"><span class="float-end">{{team2_value}}</span></div>
      </div>                
  </div>
</template>

<script>
export default {
  name: 'StatsProgress',
  data(){
          return {
              background_color:'#ffd029',
          }
      },
  props: ['team1_value','team2_value','tittle_stat','indice','skin'],
  computed:{
      percent_progress(){
          let total = this.$props.team1_value + this.$props.team2_value;
          let percent = 100 / total;
          let percent_progress = percent * this.$props.team1_value;
          this.background_color = Number.isNaN(percent_progress) ? '#dbdada' : this.background_color;
          return percent_progress;
      }
  },
  mounted(){
    //console.log(this.indice);
    //console.log(this.estadistica);
  }    
}
</script>

<style scoped>
.div_progress_stat{
  height: 6px;   
  height: 0.5rem;
}

.div_team1_value{
  font-size: small; 
  font-weight: 600; 
  color: #53bbff;
}

.div_team2_value{
  font-size: small; 
  font-weight: 600; 
  color: #ffd029;
}
</style>
